import { Component, EventEmitter, Output, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AcceptTradeInVoucherAction } from '@app/sales/states/customer-product-trade-in/customer-product-trade-in.actions';
import { TradeInSelectors } from '@app/sales/states/customer-product-trade-in/customer-product-trade-in.selectors';
import { IconNames } from '@app/shared/enums/icon-names';
import { PriceType } from '@app/shared/pipes/price-format.pipe';
import { select, Store } from '@ngxs/store';
import { TradeInDialogComponent } from '../trade-in-dialog.component';
import { MatDialogRef } from '@angular/material/dialog';
import { PriceFormatPipe } from '@app/shared/pipes/price-format.pipe';
import { IceButtonComponent } from '@app/shared/components/atoms/ice-button/ice-button.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { SpinnerComponent } from '@app/shared/components/atoms/spinner/spinner.component';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-trade-in-confirmation',
  templateUrl: './trade-in-confirmation.component.html',
  styleUrl: './trade-in-confirmation.component.scss',
  imports: [MatIcon, SpinnerComponent, MatCheckbox, FormsModule, ReactiveFormsModule, IceButtonComponent, PriceFormatPipe],
})
export class TradeInConfirmationComponent {
  private store = inject(Store);
  dialogRef = inject<MatDialogRef<TradeInDialogComponent>>(MatDialogRef);

  estimatedPrice = select(TradeInSelectors.estimatedPrice);
  deviceDisplayName = select(TradeInSelectors.deviceDisplayName);
  imei = select(TradeInSelectors.imei);
  vendorSubsidy = select(TradeInSelectors.vendorSubsidy);
  iceSubsidyForZeroPrice = select(TradeInSelectors.iceSubsidyForZeroPrice);
  totalPrice = select(TradeInSelectors.totalPrice);
  isCalculatingVendorSubsidy = select(TradeInSelectors.isCalculatingVendorSubsidy);

  @Output() backClicked = new EventEmitter<void>();

  PriceType = PriceType;
  IconNames = IconNames;

  confirmationTerms = new FormControl(false);

  addToCartClicked(): void {
    this.store.dispatch(new AcceptTradeInVoucherAction());
    this.dialogRef.close();
  }
}
